export var QuiSizeEnum;
(function (QuiSizeEnum) {
    QuiSizeEnum["None"] = "none";
    QuiSizeEnum["ExtraExtraSmall"] = "2xs";
    QuiSizeEnum["ExtraSmall"] = "xs";
    QuiSizeEnum["Small"] = "sm";
    QuiSizeEnum["Medium"] = "md";
    QuiSizeEnum["Large"] = "lg";
    QuiSizeEnum["Larger"] = "2lg";
    QuiSizeEnum["ExtraLarge"] = "xl";
    QuiSizeEnum["ExtraExtraLarge"] = "2xl";
})(QuiSizeEnum || (QuiSizeEnum = {}));
